<template>
    <center>
        <button id="login-sso-btn" type="primary"  @click="handleLoginSSO">
            <svg class="login-type-icon" width="20" height="20" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
                <path
                d="M25.2798 5.4184C25.4931 5.27642 25.7437 5.20067 26 5.20067C26.2563 5.20067 26.5068 5.27642 26.7202 5.4184C31.6286 8.7274 37.2239 10.8796 43.0846 11.713C43.3942 11.7574 43.6775 11.912 43.8824 12.1484C44.0873 12.3848 44.2 12.6872 44.2 13V24.2866C43.5327 23.2829 42.643 22.4466 41.6 21.8426V14.1128C36.4493 13.2404 31.5096 11.4039 27.04 8.6996L26 8.0522L24.96 8.6996C20.4904 11.4039 15.5506 13.2404 10.4 14.1128V24.7C10.4 33.5192 15.5168 39.9438 26 44.1038V44.2C26 45.0892 26.2236 45.9238 26.6162 46.657L26.468 46.7142C26.1668 46.8304 25.8332 46.8304 25.532 46.7142C13.8008 42.198 7.79999 34.814 7.79999 24.7V13C7.80004 12.6868 7.91317 12.3841 8.11857 12.1477C8.32398 11.9112 8.60786 11.7568 8.91799 11.713C14.7778 10.8792 20.3721 8.72704 25.2798 5.4184V5.4184ZM32.5 31.2V28.6C32.5 27.2209 33.0478 25.8982 34.023 24.923C34.9982 23.9479 36.3209 23.4 37.7 23.4C39.0791 23.4 40.4018 23.9479 41.3769 24.923C42.3521 25.8982 42.9 27.2209 42.9 28.6V31.2H44.2C44.8895 31.2 45.5509 31.4739 46.0385 31.9615C46.5261 32.4491 46.8 33.1104 46.8 33.8V44.2C46.8 44.8896 46.5261 45.5509 46.0385 46.0385C45.5509 46.5261 44.8895 46.8 44.2 46.8H31.2C30.5104 46.8 29.8491 46.5261 29.3615 46.0385C28.8739 45.5509 28.6 44.8896 28.6 44.2V33.8C28.6 33.1104 28.8739 32.4491 29.3615 31.9615C29.8491 31.4739 30.5104 31.2 31.2 31.2H32.5ZM35.1 28.6V31.2H40.3V28.6C40.3 27.9104 40.0261 27.2491 39.5385 26.7615C39.0509 26.2739 38.3895 26 37.7 26C37.0104 26 36.3491 26.2739 35.8615 26.7615C35.3739 27.2491 35.1 27.9104 35.1 28.6ZM39.65 39C39.65 38.4828 39.4445 37.9868 39.0788 37.6211C38.7131 37.2554 38.2172 37.05 37.7 37.05C37.1828 37.05 36.6868 37.2554 36.3211 37.6211C35.9554 37.9868 35.75 38.4828 35.75 39C35.75 39.5172 35.9554 40.0132 36.3211 40.3789C36.6868 40.7445 37.1828 40.95 37.7 40.95C38.2172 40.95 38.7131 40.7445 39.0788 40.3789C39.4445 40.0132 39.65 39.5172 39.65 39Z" />
            </svg>
            &ensp;
            <span>
            <b> Or login using Viettel SSO </b>
            </span>
        </button>
    </center>
</template>

<script>
import CommonUtils from "@/utils/common-utils";
import NetworkService from "@/services/NetworkService";

export default {
    name: "LoginSSO",
    mixins: [CommonUtils],
    data(){
        return{
            isPrivateNetwork: false
        }
    },
    created() {
        var authToken = this.getLocalStorageObject("zimbra_token");
        if (authToken != null) {
            this.removeLocalStorage("zimbra_token");
        }
        this.deleteAllCookies();
        this.removeLocalStorage("CONFIG_AVATAR");
        this.removeLocalStorage("token_sso");
        this.removeLocalStorage("data_compose");
    },
    mounted() {
        //https://10.58.71.179:8225/sso/login
        // const URL = this.$configZimbra.ENDPOINT.ssoAddress + '/login?service=';
        // const serviceUrl = this.$configZimbra.CLIENT_ADDRESS + '/auth-sso';
        // window.location.href = URL + encodeURIComponent(serviceUrl) + '&appCode=' + encodeURIComponent(this.$configZimbra.APP_CODE);
    },
    methods: {
        async handleLoginSSO(){
            const response = await NetworkService.checkInfoPrivate();
            this.isPrivateNetwork = response?.data?.isPrivateIp || false;
            // this.isPrivateNetwork = true;
            const URL = (this.isPrivateNetwork ? this.$configZimbra.ENDPOINT.ssoAddressPrivate :
                this.$configZimbra.ENDPOINT.ssoAddress ) + '/login?service=';
            const serviceUrl = this.$configZimbra.CLIENT_ADDRESS + '/auth-sso';
            window.location.href = URL + encodeURIComponent(serviceUrl) + '&appCode=' + encodeURIComponent(this.$configZimbra.APP_CODE);
        },
    },
};
</script>

<style></style>
